import { render, staticRenderFns } from "./ConsultationTypeSwitcher.vue?vue&type=template&id=83508ec8&scoped=true"
import script from "./ConsultationTypeSwitcher.vue?vue&type=script&lang=js"
export * from "./ConsultationTypeSwitcher.vue?vue&type=script&lang=js"
import style0 from "./ConsultationTypeSwitcher.vue?vue&type=style&index=0&id=83508ec8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83508ec8",
  null
  
)

export default component.exports